// User
export const LOADING_USER = 'loadingUser'
export const SET_USER = 'setUser'
export const UNSET_USER = 'unsetUser'

// Notifications
export const SET_NOTIFICATION = 'setNotification'
export const UNSET_NOTIFICATION = 'unsetNotification'